import { queryOptions } from "@tanstack/react-query";
import {
  retrieveAttachmentContent,
  retrieveAttachmentPreview,
} from "@/lib/data/requests/chat-attachments";

export const attachmentPreviewQueryOptions = (
  id: string,
  processingId?: string,
) =>
  queryOptions({
    queryKey: ["chat-attachment-preview", id, processingId],
    queryFn: () => retrieveAttachmentPreview(id, processingId),
    staleTime: 60_000,
    gcTime: 60_000,
    retry: false,
  });

export const attachmentContentQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["chat-attachment-content", id],
    queryFn: () => retrieveAttachmentContent(id),
    refetchInterval: (query) =>
      query.state.status !== "error" &&
      ["complete", "failed"].includes(query.state.data?.status ?? "")
        ? false
        : 3000,
    staleTime: 0,
    retry: 2,
  });
